import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { AnalyticsProvider } from "@/lib/analytics";
import { AuthProvider } from "@/lib/auth";
import { queryClient } from "@/lib/query";

import { router } from "./routes";

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {/* Inside AuthProvider: analytics needs the user to identify. Route
            tracking itself lives in AppShell, which is inside the router. */}
        <AnalyticsProvider>
          <RouterProvider router={router} />
        </AnalyticsProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
